// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"a893c2df","286":"3aa21a5f","488":"655542ce"}[chunkId] + ".chunk.js";
};